/* ==========================================================================
   נגישות + וואטסאפ.
   ההעדפות נשמרות ב-localStorage ומוחלות מיד בטעינה הבאה.
   ========================================================================== */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = document.documentElement;

  var KEY = 'nm.a11y.v1';
  var DEF = { scale: 1, spacing: false, font: false, links: false, contrast: '', motion: true, cursor: false, focus: false };
  var S;

  function load() {
    try { S = Object.assign({}, DEF, JSON.parse(localStorage.getItem(KEY) || '{}')); }
    catch (e) { S = Object.assign({}, DEF); }
  }
  function save() {
    try { localStorage.setItem(KEY, JSON.stringify(S)); } catch (e) { /* אחסון חסום */ }
  }

  function apply() {
    root.style.setProperty('--a11y-scale', S.scale);
    set('data-a11y-scale', S.scale !== 1 ? String(S.scale) : null);
    set('data-a11y-spacing', S.spacing ? 'on' : null);
    set('data-a11y-font', S.font ? 'on' : null);
    set('data-a11y-links', S.links ? 'on' : null);
    set('data-a11y-contrast', S.contrast || null);
    set('data-a11y-motion', S.motion ? null : 'off');
    set('data-a11y-cursor', S.cursor ? 'on' : null);
    set('data-a11y-focus', S.focus ? 'on' : null);
    paint();
  }
  function set(attr, val) {
    if (val === null) root.removeAttribute(attr); else root.setAttribute(attr, val);
  }

  load();
  apply();   // מוחל לפני שהמשתמש נוגע במשהו, כדי שההעדפה תישמר בין עמודים

  /* ---------- סנכרון מצב הכפתורים ---------- */
  function paint() {
    var panel = $('#a11yPanel');
    if (!panel) return;
    $$('[data-a11y]', panel).forEach(function (b) {
      var k = b.getAttribute('data-a11y');
      var v = b.getAttribute('data-val');
      var on;
      if (k === 'contrast') on = S.contrast === v;
      else if (k === 'motion') on = !S.motion;
      else if (k === 'scale') on = false;
      else on = !!S[k];
      b.setAttribute('aria-pressed', String(on));
    });
    var out = $('#a11yScale');
    if (out) out.textContent = Math.round(S.scale * 100) + '%';
    var n = countActive();
    var dot = $('#a11yDot');
    if (dot) dot.hidden = n === 0;
  }
  function countActive() {
    var n = 0;
    if (S.scale !== 1) n++;
    ['spacing', 'font', 'links', 'cursor', 'focus'].forEach(function (k) { if (S[k]) n++; });
    if (S.contrast) n++;
    if (!S.motion) n++;
    return n;
  }

  /* ---------- פעולות ---------- */
  function act(k, v) {
    if (k === 'scale') {
      S.scale = Math.min(1.6, Math.max(0.9, Math.round((S.scale + (+v)) * 100) / 100));
    } else if (k === 'contrast') {
      S.contrast = S.contrast === v ? '' : v;
    } else if (k === 'motion') {
      S.motion = !S.motion;
    } else if (k === 'reset') {
      S = Object.assign({}, DEF);
    } else {
      S[k] = !S[k];
    }
    save(); apply();
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-a11y]');
    if (!b) return;
    e.preventDefault();
    act(b.getAttribute('data-a11y'), b.getAttribute('data-val'));
  });

  /* ---------- פתיחה וסגירה ---------- */
  function wireToggle(btnSel, panelSel) {
    var btn = $(btnSel), panel = $(panelSel);
    if (!btn || !panel) return null;
    function open() {
      closeAllPanels();
      panel.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      var f = panel.querySelector('button, [href], textarea');
      if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 150);
    }
    function close() {
      panel.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    }
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      panel.classList.contains('is-open') ? close() : open();
    });
    $$('[data-close-panel]', panel).forEach(function (x) {
      x.addEventListener('click', function () { close(); btn.focus(); });
    });
    return { open: open, close: close, panel: panel, btn: btn };
  }

  var panels = [];
  function closeAllPanels() { panels.forEach(function (p) { p && p.close(); }); }

  var a11y = wireToggle('#a11yBtn', '#a11yPanel');
  var wa = wireToggle('#waBtn', '#waPanel');
  panels = [a11y, wa];

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = panels.filter(function (p) { return p && p.panel.classList.contains('is-open'); })[0];
    if (open) { e.stopPropagation(); open.close(); open.btn.focus(); }
  });
  document.addEventListener('click', function (e) {
    panels.forEach(function (p) {
      if (!p || !p.panel.classList.contains('is-open')) return;
      if (p.panel.contains(e.target) || p.btn.contains(e.target)) return;
      p.close();
    });
  });

  paint();

  /* ======================================================================
     וואטסאפ — הרכבת ההודעה ופתיחת השיחה
     ====================================================================== */
  (function () {
    var panel = $('#waPanel');
    if (!panel) return;
    var num = panel.getAttribute('data-num');
    var ta = $('#waMsg', panel);
    var send = $('#waSend', panel);

    // הקשר המוצר מגיע מעמוד המוצר עצמו
    var ctx = panel.getAttribute('data-ctx');
    if (ctx && ta && !ta.value) ta.value = ctx;

    $$('.wa-quick button', panel).forEach(function (b) {
      b.addEventListener('click', function () {
        var t = b.getAttribute('data-msg');
        if (!ta) return;
        ta.value = ctx ? ctx + '\n' + t : t;
        ta.focus();
        $$('.wa-quick button', panel).forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
      });
    });

    if (send) {
      send.addEventListener('click', function () {
        var txt = (ta && ta.value.trim()) || 'שלום, אשמח לקבל פרטים.';
        var url = 'https://wa.me/' + num + '?text=' + encodeURIComponent(txt);
        window.open(url, '_blank', 'noopener');
      });
    }
    if (ta) {
      ta.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) { e.preventDefault(); send && send.click(); }
      });
    }
  })();
})();
